import { render, staticRenderFns } from "./QurbanCheckout.vue?vue&type=template&id=36ebcfb6"
import script from "./QurbanCheckout.vue?vue&type=script&lang=js"
export * from "./QurbanCheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports